import React from "react";
import {styled, H1, TagsField, TextField, Card} from "@reside/ui";
import {UserDto} from "../../../../utils/types/user";
import {RoleNameEnum} from "../../../../utils/types/common";

import {Avatar} from "../../../../atoms/avatar";
import {AdminRoles} from "../../../../atoms/admin-roles";

export type Props = {
  user: UserDto;
};

const AvatarContainer = styled.div`
  margin-bottom: 10px;
`;

const Container = styled(Card)`
  padding: 50px 45px;
`;

export const EditProfileForm = ({
  user: {firstName, lastName, facilities, organization},
}: Props) => {
  const isReadOnly = organization?.hasSsoConfig?.ssoIsEnabled;

  return (
    <Container>
      <H1>User Details</H1>
      <AvatarContainer>
        <Avatar size={82} name={`${firstName} ${lastName}`} />
      </AvatarContainer>
      <TextField
        name="firstName"
        type="text"
        label="First Name"
        disabled={isReadOnly}
      />
      <TextField
        name="lastName"
        type="text"
        label="Last Name"
        disabled={isReadOnly}
      />
      <TextField name="role" type="text" label="Role" disabled />
      <TextField name="email" type="text" label="Email Address" disabled />
      <TextField
        name="phone"
        type="tel"
        label="Phone"
        format="us-phone"
        disabled={isReadOnly}
      />
      <AdminRoles
        roles={[
          RoleNameEnum.FACILITY_ADMIN,
          RoleNameEnum.ADMISSIONS_DIRECTOR,
          RoleNameEnum.REGIONAL_ADMIN,
          RoleNameEnum.CLERK,
        ]}
      >
        <TagsField
          name="facilities"
          options={(facilities || []).map(({name, id}) => ({
            label: name,
            value: id,
          }))}
          label="Facilities assigned"
          disabled
          testId="facilitySelect"
        />
      </AdminRoles>
    </Container>
  );
};
